import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Row,
  Label,
  Col,
  Button,
} from "reactstrap";
import { useMutation } from "react-query";
import {
  EditSchoolName,
  MoveTeacherToSchoolAndClasses,
} from "../../actions/superUserMutations";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { fetchSchoolsForAdmin } from "../../actions/schoolActions";
import { useDispatch } from "react-redux";

export default function SuperuserSchoolEditModal(props) {
  const [newName, setNewName] = useState(props.schoolToUpdate?.name);
  const [teacherToMoveEmail, setTeacherToMoveEmail] = useState("");
  const postEditSchoolName = useMutation(EditSchoolName);
  const postMoveTeacherToSchoolAndClasses = useMutation(
    MoveTeacherToSchoolAndClasses
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setNewName(props.schoolToUpdate?.name);
  }, [props.schoolToUpdate?.name]);

  const handleToggle = () => {
    setNewName("");
    setTeacherToMoveEmail("");
    props.toggle();
  };

  const handleEditSchoolName = () => {
    if (newName.length > 0 && newName !== props.schoolToUpdate?.name) {
      postEditSchoolName.mutate(
        { id: props.schoolToUpdate.id, name: newName },
        {
          onSuccess: (data) => {
            if (data && data.status > 199 && data.status < 300) {
              dispatch(fetchSchoolsForAdmin());
              toast.success(<FormattedMessage id="NameChanged" />);
              handleToggle();
            } else {
              toast.warn(data);
              handleToggle();
            }
          },
          throwOnError: true,
          onError: (data) => {
            toast.warn(data.response.data);
            handleToggle();
          },
        }
      );
    }
  };

  const handlePostMoveTeacher = () => {
    postMoveTeacherToSchoolAndClasses.mutate(
      {
        fortKnoxCustomerNumber: props.schoolToUpdate.fortKnoxCustomerNumber,
        teacherToMoveEmail: teacherToMoveEmail,
      },
      {
        onSuccess: (data) => {
          if (data && data.status > 199 && data.status < 300) {
            toast.success(<FormattedMessage id="TeacherMoved" />);
            handleToggle();
          } else {
            toast.warn(data);
            handleToggle();
          }
        },
        throwOnError: true,
        onError: (data) => {
          toast.warn(data.response.data);
          handleToggle();
        },
      }
    );
  };

  return (
    <Modal isOpen={props.isOpen} toggle={handleToggle}>
      <ModalHeader>
        {props.schoolToUpdate && `Uppdatera ${props.schoolToUpdate.name}`}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <Label for="schoolName">
              <FormattedMessage id="ChangeNameOfSchool" />:
            </Label>
          </Col>
        </Row>
        <Row>
          <Col>
            <Input
              type="text"
              onChange={(event) => {
                setNewName(event.target.value);
              }}
              defaultValue={props.schoolToUpdate?.name}
            />
          </Col>
        </Row>
        <Row className="pt-2">
          <Col>
            <Button
              color="primary"
              outline
              onClick={() => handleEditSchoolName()}
            >
              <FormattedMessage id="Save" />
            </Button>
          </Col>
        </Row>
        <Row className="pt-4">
          <Col>
            <Label for="teacherToMoveEmail">
              <FormattedMessage id="MoveTeacherToThisSchool" />:
            </Label>
          </Col>
        </Row>
        <Row>
          <Col>
            <Input
              type="email"
              name="email"
              id="email"
              placeholder="Lärares epost"
              onChange={(event) => setTeacherToMoveEmail(event.target.value)}
            />
          </Col>
        </Row>
        <Row className="pt-2">
          <Col>
            <Button
              color="primary"
              outline
              onClick={() => handlePostMoveTeacher()}
            >
              <FormattedMessage id="Move" />
            </Button>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={() => handleToggle()}>
          <FormattedMessage id="Cancel" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
